module.exports = __webpack_public_path__ + "static/media/evaImage2.e75dd941.png";